import { Box, Button, Divider, IconButton, Stack, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import CloseCircleIcon from '../../../../assets/icons/CloseCircle.svg?react'
import { RightSidebarWrapper } from '../../../../components/Wrapper/RightSidebarWrapper'
import { useFilesStore } from '../../../../store/storeFiles'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ContextSettingCard } from '../../RequestSettingPage/components/ContextSettingCard'
import { FileCardList } from '../../RequestSettingPage/components/FileCardList'
import { FileUploaderButton } from '../../RequestSettingPage/components/FileUploaderButton'
import { FileRagSwitch } from './FileRagSwitch'

const ProjectSettingsSidebar = () => {
    const { setOpenSidebarType, projectDetail } = useWrapperStore((state) => state)
    const { filesUser, fetchFilesUser } = useFilesStore((state) => state)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const workplaceId = searchParams.get('workplaceId') ?? undefined

    useEffect(() => {
        fetchFilesUser({
            prefix: `/${workplaceId}/`,
        })
    }, [workplaceId])

    return (
        <RightSidebarWrapper>
            <Box
                sx={{
                    maxHeight: `calc(100dvh - ${120}px)`,
                    overflow: 'auto',
                }}>
                <Stack
                    direction="row"
                    sx={{ justifyContent: 'space-between', p: 2, alignItems: 'center' }}>
                    <Typography color="text" variant="h5" sx={{ fontWeight: 500 }}>
                        Настройки проекта
                    </Typography>
                    <IconButton
                        sx={{ height: '40px', padding: 0 }}
                        variant="text"
                        onClick={() => setOpenSidebarType(null)}>
                        <CloseCircleIcon />
                    </IconButton>
                </Stack>
                <Divider />
                <Box sx={{ mt: 1, px: '16px' }}>
                    <Button
                        fullWidth
                        sx={{ my: 2 }}
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            setOpenSidebarType(null)
                            navigate(`/project/${projectDetail?.id}/setting`)
                        }}>
                        Подробные настройки
                    </Button>
                    <ContextSettingCard isRequestPage={false} />
                    <Grid
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '24px',
                            alignItems: 'center',
                        }}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: '#181B25',
                            }}>
                            Вложения контекста
                        </Typography>

                        <FileUploaderButton isProject={true} idEntity={workplaceId} />
                    </Grid>
                    <Grid container>
                        <FileCardList
                            handleClick={() => {}}
                            isReadOnly={false}
                            files={filesUser}
                            idEntity={workplaceId}
                            fullWidth
                            withUpload={false}
                            // onRenderFileItemControls={(file) => <FileRagSwitch file={file} />}
                        />
                    </Grid>
                </Box>
            </Box>
        </RightSidebarWrapper>
    )
}

export default ProjectSettingsSidebar
